import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function flattenReduxFormProps(WrappedComponent) {
  class FlattenReduxFormProps extends PureComponent {
    static propTypes = {
      input: PropTypes.object,
      meta: PropTypes.object,
    };

    static defaultProps = {
      input: {},
      meta: {},
    };

    render() {
      const { input, meta, ...restProps } = this.props;

      return <WrappedComponent {...input} {...meta} {...restProps} initialValue={meta.initial} />;
    }
  }

  FlattenReduxFormProps.displayName = `FlattenReduxFormProps(${getDisplayName(WrappedComponent)})`;

  return FlattenReduxFormProps;
}

export default flattenReduxFormProps;
